<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement" style="padding-top:100px">
<p>The following involves examples of other dreams and nightmares…</p>
<p>It is four in the morning or so the church bells down the road tell me, so I half open my eyes.</p>
<p>The lamplight seeps in through the cellar window, and the harsh wind is blowing hard outside. I have been dossing here in this derelict cellar for three nights in the centre of the city. No water, no electricity, no comfort: just a place to park my bag with the few possessions I have plus a sleeping bag while I walk the streets going nowhere.</p>
<p>The few friends I have left that still speak to me call me Dosser as I doss where I fall.</p>
<p>Park benches, cellars, empty beds…anywhere.</p>
<p>I am a dosser.</p>
<p>I open up my eyes fully and see a pair of yellow vertical eyes staring at me on my chest, and then I feel the weight of something and feel a movement, some warmth.</p>
<p>And then I realise that it is a rat.</p>
<p>I sit upright, the rat scurries off, and I scream.</p>
<p>I jump up and gather my bag and run off into the cold night to dream elsewhere.</p>
<p>Yup, I am Dosser, and these are my dreams.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?522edbb2